var Handlebars = require("/Users/mauricengo/styleguide-test/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "\n<h1 class=\"product-name product-name--sm\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.pdp : depth0)) != null ? stack1.name : stack1), depth0))
    + "</h1>\n<p class=\"product-brand product-brand--sm\">\n  <a href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.pdp : depth0)) != null ? stack1.brandLink : stack1), depth0))
    + "\" title=\""
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.pdp : depth0)) != null ? stack1.brand : stack1), depth0)) != null ? stack1 : "")
    + "\" class=\"product-brand__link\">"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.pdp : depth0)) != null ? stack1.brand : stack1), depth0)) != null ? stack1 : "")
    + "</a>\n</p>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/materials/modules/product-title-small.html
// module id = 168
// module chunks = 0